import { isNil } from 'lodash';

import { type HorizonTheme } from 'utils/color/horizonTheme';

import { type TurbineInspections } from './types';

export const getTurbineColor = (theme: HorizonTheme, severity?: number, maxValue: number = 5) => {
  if (isNil(severity)) {
    return theme.mapPicturePinStroke;
  }
  if (severity >= maxValue) {
    return theme.severityMaxColor;
  }
  if (severity >= maxValue - 1) {
    return theme.severityHighColor;
  }
  return theme.green;
};

export const getTurbineInspectionData = (inspections: TurbineInspections) => {
  const { nodes = [] } = inspections ?? {};

  if (!nodes.length) {
    return;
  }

  const latestInspection = nodes[0];

  const maxSeverity =
    latestInspection?.horizonDamageObservations?.reduce(
      (max, obs) => Math.max(max, obs?.attrs?.Severity ?? 0),
      0
    ) || undefined;

  return {
    id: latestInspection?.id,
    inspectionDate: latestInspection?.inspectionDate ?? undefined,
    maxSeverity: maxSeverity,
  };
};
